<template>
  <div>
    <video-player :playVideo="playVideo" :videoToPlay="videoToPlay" />

    <video-search @search-input="searchVideos" />

    <div id="video-list" class="container-fluid wrap-video">

      <article>
        <div class="col-sm-12" v-if="showSearchResults">
          <h2>Search Results:</h2>
          <div class="row videoList">
            <div v-if="!searchedVideos.length && !loadingSearch" class="col-sm-12">
              No videos found
            </div>
            <div class="text-center" v-show="loadingSearch">
              <Spinner color="#3982c4" />
            </div>
            <div v-show="!loadingSearch" v-for="video in searchedVideos" :key="video.index" class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
              <div class="shadow-box thumbnail-box">
                <div :class="`videoPlayer ${ playVideo ? 'open' : '' }`" v-if="videoToPlay.youtube_embed_id === video.youtube_embed_id && $root.isMobile">
                  <iframe id="ytplayer" type="text/html" width="1264" height="711" :src="`https://www.youtube.com/embed/${videoToPlay.youtube_embed_id}?autoplay=1&rel=0&color=white`" frameborder="0" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>
                </div>
                <a @click="openVideoModal(video)" style="cursor: pointer" v-else>
                  <img :src="`https://img.youtube.com/vi/${video.youtube_embed_id}/hqdefault.jpg`">
                  <i class="fa fa-youtube-play videoPlay" aria-hidden="true"></i>
                </a>
                <div
                  v-if="isLoggedIn && !loadingBookmarks && !bookmarks.includes(video.youtube_embed_id)"
                  class="bookmark-project"
                  :class="bookmarks.includes(video.youtube_embed_id) ? 'project-highlight' : ''"
                  title="Bookmark this project"
                  @click.prevent="saveVideo(video)">
                </div>
                <div
                  v-else-if="bookmarks.includes(video.youtube_embed_id)"
                  class="bookmark-project"
                  :class="bookmarks.includes(video.youtube_embed_id) ? 'project-highlight' : ''"
                  title="Bookmark this project"
                  @click.prevent="unsaveVideo(video)">
                </div>
                <div>
                  <span class="vidTitle">{{ video.title }}1</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12" v-show="!showSearchResults">
          <h2 id="latest-videos">Latest Videos</h2>
          <div class="row videoList">
            <div class="text-center" v-show="loadingLatest">
              <Spinner color="#3982c4" />
            </div>
            <div v-show="!loadingLatest" v-for="video in latestVideos" :key="video.index" class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
              <div class="shadow-box thumbnail-box">
                <div :class="`videoPlayer ${ playVideo ? 'open' : '' }`" v-if="videoToPlay.youtube_embed_id === video.youtube_embed_id && $root.isMobile">
                  <iframe id="ytplayer" type="text/html" width="1264" height="711" :src="`https://www.youtube.com/embed/${videoToPlay.youtube_embed_id}?autoplay=1&rel=0&color=white`" frameborder="0" allowfullscreen></iframe>
                </div>
                <a @click="openVideoModal(video)" style="cursor: pointer" v-else>
                  <img :src="`https://img.youtube.com/vi/${video.youtube_embed_id}/hqdefault.jpg`">
                  <i class="fa fa-youtube-play videoPlay" aria-hidden="true"></i>
                </a>
                <div
                  v-if="isLoggedIn && !loadingBookmarks && !bookmarks.includes(video.youtube_embed_id)"
                  class="bookmark-project"
                  :class="bookmarks.includes(video.youtube_embed_id) ? 'project-highlight' : ''"
                  title="Bookmark this project"
                  @click.prevent="saveVideo(video)">
                </div>
                <div
                  v-else-if="bookmarks.includes(video.youtube_embed_id)"
                  class="bookmark-project"
                  :class="bookmarks.includes(video.youtube_embed_id) ? 'project-highlight' : ''"
                  title="Bookmark this project"
                  @click.prevent="unsaveVideo(video)">
                </div>
                <div>
                  <span class="vidTitle">{{ video.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12" v-show="!showSearchResults">
          <div v-for="videoCategory in videoCategories" :key="videoCategory.index">
            <h2 :id="videoCategory.category.name.toLowerCase().replace(' ', '-')">{{ videoCategory.category.name }}</h2>
            <div class="row videoList" v-if="!showSearchResults && videoCategory.videos.length">
              <div class="text-center" v-show="loadingCategories">
                <Spinner color="#3982c4" />
              </div>
              <div v-show="!loadingCategories" v-for="video in videoCategory.category.top_videos" :key="video.index" class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                <div class="shadow-box thumbnail-box">
                  <div :class="`videoPlayer ${ playVideo ? 'open' : '' }`" v-if="videoToPlay.youtube_embed_id === video.youtube_embed_id && $root.isMobile">
                    <iframe id="ytplayer" type="text/html" width="1264" height="711" :src="`https://www.youtube.com/embed/${videoToPlay.youtube_embed_id}?autoplay=1&rel=0&color=white`" frameborder="0" allowfullscreen></iframe>
                  </div>
                  <a @click="openVideoModal(video)" style="cursor: pointer" v-else>
                    <img :src="`https://img.youtube.com/vi/${video.youtube_embed_id}/hqdefault.jpg`">
                    <i class="fa fa-youtube-play videoPlay" aria-hidden="true"></i>
                  </a>
                  <div
                    v-if="isLoggedIn && !loadingBookmarks && !bookmarks.includes(video.youtube_embed_id)"
                    class="bookmark-project"
                    :class="bookmarks.includes(video.youtube_embed_id) ? 'project-highlight' : ''"
                    title="Bookmark this project"
                    @click.prevent="saveVideo(video)">
                  </div>
                  <div
                    v-else-if="bookmarks.includes(video.youtube_embed_id)"
                    class="bookmark-project"
                    :class="bookmarks.includes(video.youtube_embed_id) ? 'project-highlight' : ''"
                    title="Bookmark this project"
                    @click.prevent="unsaveVideo(video)">
                  </div>
                  <div>
                    <span class="vidTitle">{{ video.title }}</span>
                  </div>
                </div>
              </div>

              <div v-show="!loadingCategories" v-for="video in videoCategory.videos" :key="video.index" class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                <div class="shadow-box thumbnail-box">
                  <div :class="`videoPlayer ${ playVideo ? 'open' : '' }`" v-if="videoToPlay.youtube_embed_id === video.youtube_embed_id && $root.isMobile">
                    <iframe id="ytplayer" type="text/html" width="1264" height="711" :src="`https://www.youtube.com/embed/${videoToPlay.youtube_embed_id}?autoplay=1&rel=0&color=white`" frameborder="0" allowfullscreen></iframe>
                  </div>
                  <a @click="openVideoModal(video)" style="cursor: pointer" v-else>
                    <img :src="`https://img.youtube.com/vi/${video.youtube_embed_id}/hqdefault.jpg`">
                    <i class="fa fa-youtube-play videoPlay" aria-hidden="true"></i>
                  </a>
                  <div
                    v-if="isLoggedIn && !loadingBookmarks && !bookmarks.includes(video.youtube_embed_id)"
                    class="bookmark-project"
                    :class="bookmarks.includes(video.youtube_embed_id) ? 'project-highlight' : ''"
                    title="Bookmark this project"
                    @click.prevent="saveVideo(video)">
                  </div>
                  <div
                    v-else-if="bookmarks.includes(video.youtube_embed_id)"
                    class="bookmark-project"
                    :class="bookmarks.includes(video.youtube_embed_id) ? 'project-highlight' : ''"
                    title="Bookmark this project"
                    @click.prevent="unsaveVideo(video)">
                  </div>
                  <div>
                    <span class="vidTitle">{{ video.title }}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </article>
    </div>
  </div>
</template>

<script>
/**
 * Gets the video data for the '/video' landing page.
 * Associated files: 'videoPlayer.vue', 'videoSearch.vue', 'video.js' and 'videos.blade.php'
 * @displayName Video List
 * TODO: split or combine the three video sections (latest, search, categories).
 * TODO: move the bookmark functionality into it's own component.
 */

import videoSearch from './videoSearch.vue';
import videoPlayer from './videoPlayer.vue';
import Spinner from '../Spinner.vue';

export default {
  name: 'video-list',

  components: {
    videoSearch,
    videoPlayer,
    Spinner,
  },

  data() {
    return {
      latestVideos: [],
      categories: [],
      videoCategories: [],
      myVideos: [],
      bookmarks: [],
      searchText: '',
      searchedVideos: [],
      showSearchResults: false,
      playVideo: false,
      videoToPlay: {},
      loadingLatest: true,
      loadingCategories: true,
      loadingSearch: true,
      loadingBookmarks: true,
      anchor: window.location.href.includes('#') ? window.location.href.substr(window.location.href.indexOf('#') + 1) : '',
      scrollToAnchor: true
    };
  },

  computed: {
    isLoggedIn() {
      return this.$root.isLoggedIn;
    },
  },

  watch: {
    loadingCategories(loading) {
      if (!loading && this.scrollToAnchor) {
        this.scrollToAnchor = false;
        setTimeout(this.scrollTo, 500, '#' + this.anchor, 165);
      }
    },

    isLoggedIn() {
      this.setBookmarks();
    }
  },

  created() {
    this.getCategoryVideos();
    this.getLatestVideos();
  },

  methods: {
    setBookmarks() {
      let vm = this;

      if (!vm.myVideos.length && !vm.bookmarks.length) {
        let userVideosUrl = '/api/proxify/me/videos';

        axios.get(userVideosUrl)
          .then(({data: response}) => {
            vm.myVideos = response;

            for (let bookmark of response) {
              vm.bookmarks.push(bookmark.youtube_embed_id);
            }

            vm.loadingBookmarks = false;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    async getLatestVideos() {
      const params = {
        orderdir: 'desc',
        limit: 6
      };
      const latestVideosUrl = `/api/proxify/domains/prismatic/videos`;

      try {
        const { data: latestVideos } = (await axios.get(latestVideosUrl, { params: params })).data;

        this.latestVideos = latestVideos;
        this.loadingLatest = false;
      } catch(error) {
        console.log(error);
      }
    },

    async getCategoryVideos() {
      const videoCategoriesUrl = '/api/proxify/domains/prismatic/shop/categories';
      const queryParams = {
        type: 'video',
        fields: 'id,code,name,title,sub_categories.**'
      };

      try {
        const { data: videoCategories } = (await axios.get(videoCategoriesUrl, { params: queryParams })).data;
        let vm = this;
        let parentVideoCategory = videoCategories.filter(cat => cat.sub_categories.length);
        let videoSubCategories = parentVideoCategory[0].sub_categories;

        if(parentVideoCategory.length) {
          for (let category of videoSubCategories) {
            if (category.enabled && category.code !== 'pris_featured_videos') {
              const categoryVideosUrl = `/api/proxify/domains/prismatic/shop/categories/${category.id}/videos`;

              try {
                const {data: categoryVideos} = (await axios.get(categoryVideosUrl)).data;

                let videoGroup = {
                  category: category,
                  videos: categoryVideos.reverse(),
                  topVidIds: category.top_videos.map(vid => {
                    return vid.id.toString()
                  })
                };

                vm.videoCategories.push(videoGroup);
              } catch (error) {
                console.error(error);
              }
            }
          }
        }

        this.loadingCategories = false;
        this.loadingBookmarks = false;
      } catch(error) {
        console.log(error);
      }
    },

    openVideoModal(video) {
      this.playVideo = true;
      if (!this.$root.isMobile) {
        this.scrollTo('.videoPlayer', 79);
      }
      this.videoToPlay = video;
    },

    formatDate(video) {
      const createDate = moment(video.created_at, 'YYYY-MM-DD');
      return createDate.format('MMMM D, Y');
    },

    mobileSearchVideos() {
      if (this.searchText.length > 2) {
        this.searchShop();
      }
    },

    searchVideos(search) {
      console.log(search);
      let vm = this;
      vm.loadingSearch = true;
      vm.videoToPlay = {};
      vm.playVideo = false;

      let queryParams = {};

      if (search.length) {
        queryParams.q = search;
      } else {
        vm.showSearchResults = false;
        return;
      }

      let searchVideosUrl = `/api/proxify/domains/prismatic/videos`;
      axios.get(searchVideosUrl, {
        params: queryParams,
      })
           .then(({data: response}) => {
             vm.showSearchResults = true;
             vm.searchedVideos = response.data;
             vm.loadingSearch = false;
           })
           .catch(error => {
             console.log(error);
           });

      vm.loading = false;
    },

    saveVideo(video) {
      let vm = this;
      let userVideoUrl = `/api/proxify/me/videos/${ video.id }`;
      axios.put(userVideoUrl)
           .then(({data: response}) => {
             console.log('bookmark this video', response);
             vm.bookmarks.push(video.youtube_embed_id);
           })
           .catch(error => {
             console.log(error);
           });
    },

    unsaveVideo(video) {
      let vm = this;
      let userVideoUrl = `/api/proxify/me/videos/${ video.id }`;
      axios.delete(userVideoUrl)
           .then(({data: response}) => {
             console.log('remove this video from bookmarks', response);
             vm.bookmarks = vm.bookmarks.filter(e => e !== video.youtube_embed_id);
           })
           .catch(error => {
             console.log(error);
           });
    },

    scrollTo() {
      let target = 0;

      $('html, body').animate({
        scrollTop: target,
      }, 500);
    },
  },
}
</script>

<style lang="scss" scoped>
  // IMG PATH
  $imgDir: '../../../img/';

  .bookmark-project {
    position: absolute;
    z-index: 3;
    left: 20px;
    top: 0;
    cursor: pointer;
    width: 29px;
    height: 55px;
    opacity: .4;
    transition: visibility .3s, opacity .3s;
    background: url($imgDir + 'arrow-bookmark.svg') -108px 0 no-repeat;
    background-size: 165px auto;


    &:hover .bookmark-project {
      visibility: visible;
      opacity: .6;
      background: url($imgDir + 'arrow-bookmark.svg') -108px 0 no-repeat;
      background-size: 165px auto;
    }
  }

  .bookmark-project.project-highlight {
    visibility: visible;
    opacity: 1;
    background: url($imgDir + 'arrow-bookmark.svg') -138px 0 no-repeat;
    background-size: 166px auto;
    left: 21px;
  }
</style>